import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import {
  getBillCycleList,
  getBillCycleOptions,
  getBulkBillDraft,
  getHistorySummary,
  getSingleBillDraft,
  getSingleBills,
} from "./api";

export const useSingleBillList = (queryParams?: Record<string, any>) => {
  return useSmartQuery(
    [
      QueryKeyFactory.module.bx.billHistory.singleBill(queryParams),
      queryParams?.page,
    ],
    () => getSingleBills(queryParams)
  );
};

export const useBillCycleList = (queryParams: Record<string, any>) => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.billHistory.billCycle(), queryParams],
    () => getBillCycleList(queryParams)
  );
};

export const useSingleBillDraftList = (page: number) => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.billHistory.singleBillDraft(), page],
    () => getSingleBillDraft(page)
  );
};

export const useHistorySummary = () => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.billHistory.historySummary()],
    () => getHistorySummary()
  );
};

export const useBulkBillDraftList = (page: number) => {
  return useSmartQuery(
    [QueryKeyFactory.module.bx.billHistory.BulkBillDraft(), page],
    () => getBulkBillDraft(page)
  );
};

export const useBillCycleOptions = () => {
  return useSmartQuery(QueryKeyFactory.module.bx.billMaster.billCycle(), () =>
    getBillCycleOptions()
  );
};
